import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  patchRequest,
} from "../api/request";

export const getTransactions = () => {
  return getRequest("/transactions");
};

export const getTransactionById = (id) => {
  return getRequest(`/transactions/${id}`);
};

export const createTransaction = (data) => {
  return postRequest("/transaction", data);
};

export const updateTransaction = (id, data) => {
  return putRequest(`/transactions/${id}`, data);
};

// DELETE /api/transactions/:id/section/:sectionType
export const deleteTransactionBySection = (id, sectionType) => {
  return deleteRequest(`/transaction/${id}/section/${sectionType}`);
};
// /:id/section/:sectionType/revert
export const revertTransactionBySection = (id, section) => {
  return postRequest(`/transaction/${id}/section/${section}/revert`);
};

export const getTxSerialNumber = () => {
  return getRequest("/transaction/serialNo");
};

export const getTxBySerialNumber = (srno) => {
  return getRequest(`/transaction/search?serial=${srno}`);
};

export const pendingTransactions = (filter = "all") => {
  return getRequest(`/transaction/pending-tx?filter=${filter}`);
};

export const pendingTransactionsByDate = (params) => {
  return getRequest(`/transaction/ratework/pending-tx`, params);
};
export const settleTransaction = (txId, paylod) => {
  return patchRequest(`/transaction/${txId}/settle`, paylod);
};

export const updateTransactionById = (txId, paylod) => {
  return patchRequest(`/transaction/${txId}`, paylod);
};
